import React, { useState } from 'react'
import { X } from 'lucide-react'
import styles from './style.module.scss'
import cls from 'classnames'
import { useParams } from 'next/navigation'
import { TLanguages } from 'core/config/locale'
import { useLocale } from 'core/components/Locale'
import locales from 'core/config/locale.json'
import { useAppSetting, useUpdateAppSetting } from '@/components/appStore'
import { localCache } from '@hotcoin/utils/dist/utils/cache'
import { Environment } from '@/config'

type LanguageAndCurrencyContentProps = {
  onClose?: () => void
  showCloseButton?: boolean
}

const LanguageAndCurrencyContent: React.FC<LanguageAndCurrencyContentProps> = ({ onClose, showCloseButton = true }) => {
  const t = useLocale()
  const locale = useAppSetting('locale')
  const currencyCode = useAppSetting('currencyCode')
  const updateAppSetting = useUpdateAppSetting()
  const [key, setKey] = useState('1')
  const params = useParams<{ lang: TLanguages }>()

  let currencyList = []
  if (typeof window !== 'undefined') {
    currencyList = localCache.getCache('settings')?.currencyList || []
  }

  /**
   * 多语言切换，更新地址栏与 多语言相关参数
   * @param url
   * @param locale
   */
  const replaceUrlPathLang = (url, locale) => {
    const langRegex = /\/[a-zA-Z_]+\//
    // 提取重定向参数值
    const redirectParam = 'redirect='
    const redirectIndex = url.indexOf(redirectParam)
    let redirectValue = ''
    if (redirectIndex !== -1) {
      const start = redirectIndex + redirectParam.length
      const end = url.indexOf('&', start)
      if (end !== -1) {
        redirectValue = url.slice(start, end)
      } else {
        redirectValue = url.slice(start)
      }
      // 解码重定向参数值
      redirectValue = decodeURIComponent(redirectValue)
      // 替换重定向参数值中的多语言标识
      redirectValue = redirectValue.replace(langRegex, `/${locale}/`)
      // 编码重定向参数值
      redirectValue = encodeURIComponent(redirectValue)
    }

    // 替换 URL 中的多语言标识
    url = url.replace(langRegex, `/${locale}/`)

    // 更新重定向参数值
    if (redirectIndex !== -1) {
      const start = redirectIndex + redirectParam.length
      const end = url.indexOf('&', start)
      if (end !== -1) {
        url = url.slice(0, start) + redirectValue + url.slice(end)
      } else {
        url = url.slice(0, start) + redirectValue
      }
    }
    return url
  }

  const withLonestLocale =
    typeof window !== 'undefined' && window.hotcoin === Environment.PRODUCTION
      ? locales
      : [...locales, { name: '最长文案', value: 'longest' }]

  return (
    <div>
      <div className={styles.tableHeader}>
        <div className={key === '1' ? styles.keyActive : styles.Key} onClick={() => setKey('1')}>
          {t('index_125')}
        </div>
        <div className={key === '2' ? styles.keyActive : styles.Key} onClick={() => setKey('2')}>
          {t('index_126')}
        </div>
        {showCloseButton && (
          <div onClick={onClose} className={styles.close}>
            <X size={28} />
          </div>
        )}
      </div>
      <div className={styles.tableContent}>
        <div className={styles.infoGrid} style={{ display: key === '1' ? 'grid' : 'none' }}>
          {withLonestLocale.map((localeItem) => (
            <div
              className={cls(styles['gutter-row'], styles.infoItem, { [styles.active]: locale === localeItem.value })}
              key={localeItem.value}
              onClick={() => {
                updateAppSetting('locale', localeItem.value)
                onClose?.()
                if (params?.lang !== localeItem.value) {
                  window.location.href = replaceUrlPathLang(location.href, localeItem.value)
                }
              }}
            >
              <div style={{ whiteSpace: 'nowrap' }}>{localeItem.name}</div>
            </div>
          ))}
        </div>
        <div className={styles.infoGrid} style={{ display: key === '2' ? 'grid' : 'none' }}>
          {currencyList?.map((currencyItem) => (
            <div
              className={cls(styles['gutter-row'], styles.infoItem, {
                [styles.active]: currencyCode === currencyItem.currencyCode,
              })}
              key={currencyItem.id}
              onClick={() => {
                updateAppSetting('currencySymbol', currencyItem.symbol)
                updateAppSetting('currencyCode', currencyItem.currencyCode)
                onClose?.()
              }}
            >
              <div>{`${currencyItem.currencyCode}-${currencyItem.symbol}`}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default LanguageAndCurrencyContent
